export default __webpack_public_path__ + "static/media/add_emoji.a7217a36.svg";